module.exports = __webpack_public_path__ + "img/laohuang_des_3.7f2bc747.jpg";